"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionControllerSignature = void 0;
const FormQuestionType_1 = __importDefault(require("../../FormQuestionType"));
const getQuestionConfig_1 = __importDefault(require("../../helpers/getQuestionConfig"));
const createFormQuestionConfigBase_1 = __importDefault(require("../../mutations/createFormQuestionConfigBase"));
const DefaultFormQuestionController_1 = require("../DefaultFormQuestionController");
exports.QuestionControllerSignature = Object.assign(Object.assign({}, DefaultFormQuestionController_1.DefaultFormQuestionController), { areSame: (a, b) => {
        if (a.type !== FormQuestionType_1.default.SIGNATURE || b.type !== FormQuestionType_1.default.SIGNATURE)
            return false;
        return DefaultFormQuestionController_1.DefaultFormQuestionController.areSame(a, b);
    }, compress: (q) => {
        const config = (0, getQuestionConfig_1.default)(FormQuestionType_1.default.SIGNATURE, q);
        return { [FormQuestionType_1.default.SIGNATURE]: config };
    }, canScore: () => {
        return false;
    }, createConfig: (o = {}) => {
        return Object.assign(Object.assign({}, (0, createFormQuestionConfigBase_1.default)({ scoring: exports.QuestionControllerSignature.canScore() })), (o || {}));
    }, createExampleConfig: () => {
        return exports.QuestionControllerSignature.createConfig();
    } });
exports.default = exports.QuestionControllerSignature;
